var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col left" },
      [
        _c("div", { staticClass: "header" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("dash.inbox.title.section")) +
                "\n      "
            ),
          ]),
          _c("div", { staticClass: "cta" }, [
            _c("div", { staticClass: "search" }, [
              _c("div", { staticClass: "container-svg-serach" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "21",
                      height: "21",
                      viewBox: "0 0 21 21",
                      fill: "none",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M17.0625 8.53125C17.0625 10.4139 16.4514 12.1529 15.4219 13.5639L20.6145 18.7605C21.1271 19.2732 21.1271 20.1059 20.6145 20.6186C20.1018 21.1312 19.2691 21.1312 18.7564 20.6186L13.5639 15.4219C12.1529 16.4555 10.4139 17.0625 8.53125 17.0625C3.81855 17.0625 0 13.2439 0 8.53125C0 3.81855 3.81855 0 8.53125 0C13.2439 0 17.0625 3.81855 17.0625 8.53125ZM8.53125 14.4375C9.30687 14.4375 10.0749 14.2847 10.7915 13.9879C11.5081 13.6911 12.1592 13.256 12.7076 12.7076C13.256 12.1592 13.6911 11.5081 13.9879 10.7915C14.2847 10.0749 14.4375 9.30687 14.4375 8.53125C14.4375 7.75563 14.2847 6.9876 13.9879 6.27103C13.6911 5.55445 13.256 4.90335 12.7076 4.3549C12.1592 3.80645 11.5081 3.3714 10.7915 3.07459C10.0749 2.77777 9.30687 2.625 8.53125 2.625C7.75563 2.625 6.98761 2.77777 6.27103 3.07459C5.55445 3.3714 4.90335 3.80645 4.3549 4.3549C3.80645 4.90335 3.3714 5.55445 3.07459 6.27103C2.77777 6.9876 2.625 7.75563 2.625 8.53125C2.625 9.30687 2.77777 10.0749 3.07459 10.7915C3.3714 11.5081 3.80645 12.1592 4.3549 12.7076C4.90335 13.256 5.55445 13.6911 6.27103 13.9879C6.98761 14.2847 7.75563 14.4375 8.53125 14.4375Z",
                        fill: "#AB6E93",
                      },
                    }),
                  ]
                ),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.textFilter,
                    expression: "textFilter",
                  },
                ],
                attrs: { placeholder: _vm.$t("dash.placeholder.search") },
                domProps: { value: _vm.textFilter },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.textFilter = $event.target.value
                  },
                },
              }),
            ]),
            _c(
              "div",
              {
                staticClass: "btn-filter",
                class: [
                  {
                    active:
                      _vm.filter.type.length < 6 ||
                      _vm.filter.status.length < 4 ||
                      !_vm.filter.flag ||
                      _vm.filter.affected_to.length ||
                      _vm.filter.evaluation.length < 4,
                  },
                ],
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "action",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.toggleFilter()
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fa-solid fa-bars-filter" }),
                    _vm.showFilter
                      ? _c(
                          "div",
                          {
                            ref: "filterInbox",
                            staticClass: "container-filter",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return (() => {}).apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "filter" }, [
                              _c("div", { staticClass: "container-dates" }, [
                                false
                                  ? _c("div", { staticClass: "dates" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.filter.dateStart,
                                            expression: "filter.dateStart",
                                          },
                                        ],
                                        attrs: {
                                          type: "date",
                                          name: "filterInboxDateStart",
                                          max: new Date()
                                            .toISOString()
                                            .split("T")[0],
                                        },
                                        domProps: {
                                          value: _vm.filter.dateStart,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.filter,
                                              "dateStart",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(
                                        "\n                    à\n                    "
                                      ),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.filter.dateEnd,
                                            expression: "filter.dateEnd",
                                          },
                                        ],
                                        attrs: {
                                          type: "date",
                                          name: "filterInboxDateEnd",
                                          min: _vm.filter.dateStart
                                            ? _vm.filter.dateStart
                                            : "",
                                          max: new Date()
                                            .toISOString()
                                            .split("T")[0],
                                        },
                                        domProps: { value: _vm.filter.dateEnd },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.filter,
                                              "dateEnd",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ])
                                  : _vm._e(),
                              ]),
                              _c("div", { staticClass: "column border" }, [
                                _c("div", { staticClass: "category type" }, [
                                  _c(
                                    "div",
                                    { staticClass: "title-category" },
                                    [
                                      _c("Checkbox", {
                                        attrs: {
                                          id: "addAllTypeEvent",
                                          isChecked: _vm.filter.type.length > 0,
                                          isLine: _vm.filter.type.length < 6,
                                          add: () =>
                                            _vm.selectAllFilter("type"),
                                          remove: () =>
                                            _vm.removeAllFilter("type"),
                                        },
                                      }),
                                      _c("h5", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("dash.inbox.filter.type.all")
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "list" },
                                    _vm._l(
                                      [
                                        "message",
                                        "comment",
                                        "mention",
                                        "rating",
                                      ],
                                      function (value) {
                                        return _c(
                                          "div",
                                          { key: value, staticClass: "choice" },
                                          [
                                            _c("Checkbox", {
                                              attrs: {
                                                id: "type-" + value,
                                                isChecked:
                                                  _vm.filter.type.includes(
                                                    value
                                                  ),
                                                add: _vm.addOptionFilter,
                                                remove: _vm.removeOptionFilter,
                                              },
                                            }),
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "dash.inbox.filter.type." +
                                                      value
                                                  )
                                                )
                                              ),
                                            ]),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "column border" }, [
                                _c("div", { staticClass: "category status" }, [
                                  _c(
                                    "div",
                                    { staticClass: "title-category" },
                                    [
                                      _c("Checkbox", {
                                        attrs: {
                                          id: "addAllStatusEvent",
                                          isChecked:
                                            _vm.filter.status.length > 0 ||
                                            _vm.filter.flag,
                                          isLine:
                                            _vm.filter.status.length < 4 ||
                                            !_vm.filter.flag,
                                          add: () =>
                                            _vm.selectAllFilter("status"),
                                          remove: () =>
                                            _vm.removeAllFilter("status"),
                                        },
                                      }),
                                      _c("h5", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "dash.inbox.filter.status.all"
                                            )
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "list" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "choice" },
                                        [
                                          _c("Checkbox", {
                                            attrs: {
                                              id: "status-flag",
                                              isChecked: _vm.filter.flag,
                                              add: _vm.addOptionFilter,
                                              remove: _vm.removeOptionFilter,
                                            },
                                          }),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "dash.inbox.filter.status.flag"
                                                )
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _vm._l(
                                        [
                                          "waiting",
                                          "treated",
                                          "removed",
                                          "hided",
                                        ],
                                        function (value) {
                                          return _c(
                                            "div",
                                            {
                                              key: value,
                                              staticClass: "choice",
                                            },
                                            [
                                              _c("Checkbox", {
                                                attrs: {
                                                  id: "status-" + value,
                                                  isChecked:
                                                    _vm.filter.status.includes(
                                                      _vm.getTranslateFilter(
                                                        value
                                                      )
                                                    ),
                                                  add: _vm.addOptionFilter,
                                                  remove:
                                                    _vm.removeOptionFilter,
                                                },
                                              }),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.inbox.filter.status." +
                                                        value
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "column" }, [
                                _c(
                                  "div",
                                  { staticClass: "category evaluation" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "title-category" },
                                      [
                                        _c("Checkbox", {
                                          attrs: {
                                            id: "addAllEvaluationEvent",
                                            isChecked:
                                              _vm.filter.evaluation.length > 0,
                                            isLine:
                                              _vm.filter.evaluation.length < 4,
                                            add: () =>
                                              _vm.selectAllFilter("evaluation"),
                                            remove: () =>
                                              _vm.removeAllFilter("evaluation"),
                                          },
                                        }),
                                        _c("h5", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "dash.inbox.filter.evaluation.all"
                                              )
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "list" },
                                      _vm._l(
                                        ["good", "normal", "bad", "none"],
                                        function (value) {
                                          return _c(
                                            "div",
                                            {
                                              key: value,
                                              staticClass: "choice",
                                            },
                                            [
                                              _c("Checkbox", {
                                                attrs: {
                                                  id: "evaluation-" + value,
                                                  isChecked:
                                                    _vm.filter.evaluation.includes(
                                                      _vm.getTranslateFilter(
                                                        value
                                                      )
                                                    ),
                                                  add: _vm.addOptionFilter,
                                                  remove:
                                                    _vm.removeOptionFilter,
                                                },
                                              }),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "badge-evaluation",
                                                  class: value,
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "dash.inbox.filter.evaluation." +
                                                          value
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "category affected_to" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "title-category" },
                                      [
                                        _c("h5", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "dash.inbox.filter.affected_to.title"
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "list" },
                                      [
                                        _vm._l(
                                          _vm.filter.affected_to.slice(0, 2),
                                          function (user, key) {
                                            return _c("img", {
                                              key: key,
                                              staticClass: "image-user",
                                              attrs: {
                                                src:
                                                  user.avatar &&
                                                  user.avatar.length
                                                    ? user.avatar
                                                    : require("../../../assets/img/ico-man.svg"),
                                              },
                                            })
                                          }
                                        ),
                                        _c("i", {
                                          staticClass: "fa-solid fa-user-plus",
                                          on: {
                                            click: function ($event) {
                                              _vm.popupSelectUsers = true
                                            },
                                          },
                                        }),
                                        _c(
                                          "vs-popup",
                                          {
                                            staticClass:
                                              "overlay groups shared-planner affected_to",
                                            attrs: {
                                              title: _vm.$t(
                                                "dash.inbox.filter.affected_to.popup.title"
                                              ),
                                              active: _vm.popupSelectUsers,
                                            },
                                            on: {
                                              "update:active": function (
                                                $event
                                              ) {
                                                _vm.popupSelectUsers = $event
                                              },
                                            },
                                          },
                                          [
                                            _vm.popupSelectUsers
                                              ? _c("component-users-selector", {
                                                  attrs: {
                                                    usersAdded:
                                                      _vm.filter.affected_to,
                                                  },
                                                  on: {
                                                    submit:
                                                      _vm.addAffectedToFilter,
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "reload",
                on: {
                  click: function ($event) {
                    return _vm.refresh()
                  },
                },
              },
              [_c("i", { staticClass: "fa-solid fa-rotate-right" })]
            ),
          ]),
        ]),
        _c("component-list-inbox", {
          attrs: {
            page: _vm.page,
            pages: _vm.pages,
            list: _vm.list.filter((e) =>
              _vm.pages.find(
                (p) => e.network == p.network && e.page == p.network_id
              )
            ),
            totalEvents: _vm.totalEvents,
            totalAllEvents: _vm.totalAllEvents,
            selected: _vm.selected,
            textFilter: _vm.textFilter,
            isLoading: _vm.isLoading || _vm.mainLoading,
            filter: _vm.filter,
          },
          on: {
            select: _vm.selectEvent,
            change: _vm.changeEvent,
            changeMultiTask: _vm.changeMultiTask,
            nextEvents: _vm.getInbox,
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col right" },
      [
        _vm.selected && _vm.selected.user
          ? _c("component-user-inbox", {
              attrs: {
                user: _vm.selected.user,
                page: _vm.pages.find(
                  (p) =>
                    p.network_id == _vm.selected.page &&
                    p.network == _vm.selected.network
                ),
              },
              on: {
                getActivities: _vm.getActivitiesUser,
                refreshEvents: _vm.refresh,
              },
            })
          : _vm._e(),
        _vm.selected
          ? _c("component-detail-inbox", {
              attrs: {
                event: _vm.selected,
                page: _vm.pages.find(
                  (p) =>
                    p.network_id == _vm.selected.page &&
                    p.network == _vm.selected.network
                ),
              },
              on: {
                change: _vm.changeEvent,
                submitComment: _vm.submitComment,
                submitLike: _vm.submitLike,
                deleteComment: _vm.deleteComment,
                hideComment: _vm.hideComment,
                updateEventMissingInfos: _vm.updateEventMissingInfos,
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }